import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const fetchLolbinApi = async (
  email: string,
  tenantName: string,
  bucket: string,
  filterPagination: string,
  computerName: string,
  computerId: string,
  key: string,
  fromDetails: boolean = false,
  computeremail: string = ""
): Promise<Object | undefined> => {
  try {
    if (!email || !tenantName) return;
    let url = `${NGROK}/api/influxdb/eventtimeline?bucketName=${bucket}&timingMode=${filterPagination}&email=${email}&resourceType=LOLBin Audit`;
    url += "&limitNeeded=false";
    if (tenantName !== null) {
      url += `&tenantName=${tenantName}`;
    }
    if (fromDetails) {
      url += `&isDeviceSpecific=true&deviceName=${computerName}&computerId=${computerId}`;
      key = computerName;
    }
    if (computeremail !== null && computeremail.length > 0) {
      url += `&computer_email=${computeremail}`;
    }
    return await apiClient<Object>({
      method: "GET",
      url
    });
  } catch (error) {
    console.error("saveToken error:", error);
  }
};

export const fetchAuditLogsApi = async (
  bucket: string,
  tenantName: string,
  filterPagination: string,
  computerName: string,
  computerId: string,
  computeremail: string,
  searchQuery: string,
  email: string,
  fromdetails: boolean,
  lastFetchedTime?: string,
  resourceType = "",
  page?: number,
  limit: number = 200,
  signal?: AbortSignal,
  customStartDate?: string,
  customEndDate?: string
): Promise<any[]> => {
  try {
    let url = `${NGROK}/api/influxdb/influxdblogsdata?bucketName=${encodeURIComponent(bucket)}&tenantName=${encodeURIComponent(tenantName)}&timingMode=${encodeURIComponent(filterPagination)}&email=${encodeURIComponent(email)}&limit=${limit}&page=${page}`;

    if (computeremail.length > 0) {
      url += `&computer_email=${encodeURIComponent(computeremail)}`;
    }
    if (resourceType) {
      url += `&resourceType=${encodeURIComponent(resourceType)}`;
    }

    if (computerName) {
      url += `&deviceName=${encodeURIComponent(computerName)}`;
    }
    if (computerId) {
      url += `&computerId=${encodeURIComponent(computerId)}`;
    }
    if (searchQuery) {
      url += `&searchParams=${encodeURIComponent(searchQuery)}`;
    }
    if (fromdetails) {
      url += `&isDeviceSpecific=true`;
    }
    if (lastFetchedTime) {
      url += `&recentstartTime=${encodeURIComponent(lastFetchedTime)}`;
    }

    // Add custom date parameters if in custom mode
    if (filterPagination === 'custom' && customStartDate && customEndDate) {
      url += `&customDateMode=true&customStartDate=${encodeURIComponent(customStartDate)}&customEndDate=${encodeURIComponent(customEndDate)}`;
    }

    const response = await apiClient<any[]>({
      method: "GET",
      url,
      signal: signal,
    });

    return response;
  } catch (error) {
    console.error("Error fetching audit logs:", error);
    return [];
  }
};
